import Vue from 'vue';
import VueRouter from 'vue-router';
// import store from '@/store/index';
// import axios from 'axios';
import { routes } from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history',
  linkExactActiveClass: 'is-active'
});

export default router;

// router.beforeEach(async (to, from, next) => {
//   // check if page requires auth and user is not logged in
//   if ((!store.getters.isLoggedIn || !store.getters.getToken) && to.meta.requiresAuth) {
//     return next('/');
//   }

//   // set default authorization header
//   const token = store.getters.getToken;
//   if (!token && to.meta.requiresAuth) {
//     return next('/');
//   } else if (!token) {
//     return next();
//   }

//   axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//   store.dispatch('headerSet', true);

//   // check if we collected user data
//   const hasUser = Object.keys(store.getters.getUser).length > 0;
//   if (!hasUser) await store.dispatch('fetchUser');

//   // redirect to dashboard if we are already logged in
//   if (to.name === 'Login') return next('/home');

//   next();
// });

// // Change title
// router.beforeEach((to, from, next) => {
//   document.title = `${process.env.VUE_APP_DISPLAY_NAME} | ${to.meta.title || '404'}`;
//   next();
// });
